import { useLocation, useNavigation, useRevalidator } from 'react-router';
import { useMemo } from 'react';

/**
 * Hook to get information relating to the search page.
 */
export function useSearch() {
    const navigation = useNavigation();
    const location = useLocation();
    const revalidator = useRevalidator();

    return {
        /**
         * The search page is currently loading search results.
         */
        isSearching: useMemo(() => {
            return (
                (navigation.state === 'loading' &&
                    navigation.location?.pathname.startsWith('/search')) ||
                (location.pathname.startsWith('/search') &&
                    revalidator.state === 'loading')
            );
        }, [navigation, location.pathname, revalidator.state]),
    };
}
